export default "__VITE_PUBLIC_ASSET__98878443__"